module.exports = __webpack_public_path__ + "static/media/NB.69b4256b.jpg";